import React from 'react';
import {
  ChipFilters,
  EmptyStateView,
  EndListView,
  ListSkeleton,
  SpinnerLoader,
} from '../../components';
import { isEmpty } from 'lodash';
import { InvoiceCard } from '../invoice-card';
import {
  getSelectedItemIds,
  Invoice,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { SVGS } from '../../assets';
import { useScroll } from '../../hooks';
import { ChipFilterSection } from '../../types';

interface InvoiceScreenProps {
  isLoading: boolean;
  invoiceData: Invoice[];
  emptyStateMap?: Record<
    string,
    {
      image: string;
      message: string;
    }
  >;
  lastPath: string | undefined;
  onInvoiceItemPress: (invoice: Invoice) => void;
  lastItemRef: React.MutableRefObject<HTMLDivElement | null>;
  setSelectInvoice?: React.Dispatch<React.SetStateAction<boolean>>;
  handleSendBulkInvoice: () => void;
  showSelection?: boolean;
  selectionModeEnabled?: boolean;
  searchKey: string;
  showSearch: boolean;
  onSearchCancel: () => void;
  isEndOfList?: boolean;
  onScroll?: () => void;
  chips?: ChipFilterSection[];
}

export const InvoiceList: React.FC<InvoiceScreenProps> = ({
  isLoading,
  invoiceData,
  onInvoiceItemPress,
  lastItemRef,
  setSelectInvoice,
  showSelection,
  selectionModeEnabled = false,
  searchKey,
  showSearch,
  onSearchCancel,
  isEndOfList,
  onScroll = () => {},
  chips,
}) => {
  const selectedInvoiceIds = useAppSelector(getSelectedItemIds);

  const { scrollRef, handleTouchStart, handleTouchMove, handleTouchEnd } =
    useScroll();

  return isLoading ? (
    <ListSkeleton />
  ) : (
    <>
      {!showSearch && searchKey.length > 0 && (
        <div className="invoice-search-info font-regular">
          <div>
            RESULTS FOR{' '}
            <span className="font-semibold">{`"${searchKey}"`}</span>
          </div>
          <div className="clear-btn font-semibold" onClick={onSearchCancel}>
            CLEAR
          </div>
        </div>
      )}

      <div
        className={`invoice-list-content ${
          selectedInvoiceIds?.length > 0 ? 'invoice-list-content-selected' : ''
        }`}
        onScroll={onScroll}
        ref={scrollRef}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {chips && (
          <ChipFilters
            sections={chips}
            chipFilterStyles={{
              marginTop: '-12px',
              alignSelf: 'flex-start',
              width: '100%',
              position: 'sticky',
              top: '-16px',
              left: '-16px',
            }}
          />
        )}
        {isEmpty(invoiceData) ? (
          <EmptyStateView
            imageSrc={SVGS.NoInvoicesFound}
            message={'No Invoices Found'}
          />
        ) : (
          <>
            {invoiceData?.map((invoiceItem) => (
              <InvoiceCard
                key={invoiceItem.id}
                invoiceItem={invoiceItem}
                onInvoiceItemPress={onInvoiceItemPress}
                showSelection={showSelection}
              />
            ))}
            <div ref={lastItemRef} className="invoice-last-item" />
            {!isEndOfList && <SpinnerLoader />}
            {isEndOfList && <EndListView />}
          </>
        )}
      </div>
    </>
  );
};
